import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';
import {family} from '../data';
import Card from '../components/Card';
import ModelProvider from '../components/modalContext';
import Img from '../components/Img';

import img_title from '../assets/img/pc04-1.png';
import {getRecord} from '../api/voteApi';
import VoteModal from '../components/VoteModal';

const ContentStyles = styled.div`
  --bg: var(--other);
  background-color: var(--bg);
  position: relative;
  z-index: 1;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 20rem;
    background-image: linear-gradient(6deg, var(--bg) 50%, white 0%);
    margin-top: -10rem;
    margin-bottom: -10rem;
  }
  .container {
    padding: 4rem 2rem;
  }
  .desc {
    position: relative;
    > p {
      position: absolute;
      top: 45%;
      left: 14%;
      padding-right: 3rem;
    }
  }
  
  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 8rem;
    }
    .desc {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .desc {
      margin-bottom: 10rem;
      > p {
        top: 40%;
      }
    }
  }
`;

const PostsGridStyles = styled.div`
  --column: repeat(2, 1fr);
  --gap: 3rem 2rem;
  display: grid;
  grid-template-columns: var(--column);
  gap: var(--gap);
  padding: 2rem;
  background-color: var(--white);
  @media (min-width: ${breakPoint.min}) {
    --column: repeat(4, 1fr);
    margin-top:  6rem;
    padding: 4rem;
  }
  @media (min-width: ${breakPoint.lgMin}) {
    --gap: 4rem 3rem;
    --column: repeat(5, 1fr);
  }
`;
const Section3 = (props) => {
  const [state, setState] = useState({
    isShow: false,
    voteId: 0,
  })

  const [voteMap, setVoteMap] = useState({});
  const handleShowModal = (show= true, id= 0) => {
    if (Date.now() > 1662307199000) {
      alert('投票已結束');
    }  else {
      setState({
        isShow: show,
        voteId: id
      })
    }

  }
  const getRecordApi = async () => {
    const record = {
	data: [{"id":4,"vote_type":2,"votes":1586},{"id":32,"vote_type":2,"votes":1663},{"id":1,"vote_type":2,"votes":1671},{"id":27,"vote_type":2,"votes":1601},{"id":6,"vote_type":2,"votes":1618},{"id":9,"vote_type":2,"votes":2804},{"id":5,"vote_type":2,"votes":1585},{"id":20,"vote_type":2,"votes":2150},{"id":30,"vote_type":2,"votes":1587},{"id":16,"vote_type":2,"votes":1613},{"id":26,"vote_type":2,"votes":1607},{"id":10,"vote_type":2,"votes":1586},{"id":2,"vote_type":2,"votes":1632},{"id":22,"vote_type":2,"votes":1588},{"id":8,"vote_type":2,"votes":1593},{"id":17,"vote_type":2,"votes":2430},{"id":28,"vote_type":2,"votes":1812},{"id":7,"vote_type":2,"votes":1621},{"id":23,"vote_type":2,"votes":1610},{"id":19,"vote_type":2,"votes":1719},{"id":24,"vote_type":2,"votes":1715},{"id":15,"vote_type":2,"votes":1623},{"id":18,"vote_type":2,"votes":1615},{"id":25,"vote_type":2,"votes":1581},{"id":29,"vote_type":2,"votes":1582},{"id":11,"vote_type":2,"votes":1595},{"id":3,"vote_type":2,"votes":1585},{"id":14,"vote_type":2,"votes":2212},{"id":31,"vote_type":2,"votes":1609},{"id":12,"vote_type":2,"votes":1676},{"id":13,"vote_type":2,"votes":1603},{"id":21,"vote_type":2,"votes":1584}]
    };
    const recordMap = {};
    if (record.data.length > 0) {
      record.data.forEach(item => {
        recordMap[item.id] = item.votes;
      })
    }
    setVoteMap(recordMap);
  }
  useEffect(() => {
    getRecordApi();
  }, [])
  return (
      <ModelProvider value={{...state, handleShowModal}}>
        <ContentStyles {...props}>
          <Container className="container">
            <div className="desc">
              <Img src={img_title} />
              <p>每個家庭都有屬於自己的風格，每每看到親子網紅的日常，總不自覺嘴角上揚，感同身受；媽媽寶寶、痞客邦、創意油管與Influenxio 圈圈共同遴選出2022年最受歡迎社群風格家庭，快來為喜歡的風格家庭投下一票吧！
              </p>
            </div>
            <PostsGridStyles className="animate__animated animate__fadeInUp animate__faster">
              {family.map(item => {
                const _vote = voteMap.hasOwnProperty(item.id) ? voteMap[item.id] : 0;
                return <Card
                    key={item.id}
                    info={item}
                    vote={_vote}
                    handleShowModal={() => handleShowModal(true, item.id)}
                />
              })}
            </PostsGridStyles>
            <VoteModal className={"theme-primary"} voteType={2} getRecordApi={getRecordApi}/>
          </Container>
        </ContentStyles>
      </ModelProvider>

  )
};

export default Section3;
